import React, { useEffect, useState } from "react";
import { Header } from "../components/Header";
import { useI18n } from "../context/I18nContext";
import { useAuth, api } from "../context/AuthContext";
import { money, dateFmt } from "../lib/format";
import { PiggyBank, ChartLineUp, HandCoins, User, Users, TrendUp, House, ClockCounterClockwise, FilePdf, Vault, ChartLineUp as ChartIcon, ShareNetwork, Copy, Gift, WhatsappLogo, PaperPlaneTilt, MagnifyingGlass, Ticket, CalendarCheck, IdentificationCard, Eye, Megaphone, CaretLeft, CaretRight, Plus, Trash, ShieldCheck, QrCode, LockKey } from "@phosphor-icons/react";
import { ClientRemittances } from "../components/ClientRemittances";
import { MyRaffleTickets } from "../components/RaffleTickets";
import { CalendarPanel } from "../components/CalendarPanel";
import { DashboardNav } from "../components/DashboardNav";
import { ActivityPanel } from "../components/ActivityFeed";
import { MemberStore } from "../components/MemberStore";
import { OnboardingModal } from "../components/OnboardingModal";
import { MemberTestimonialCard } from "../components/MemberTestimonialCard";
import { ReferralCalculator } from "../components/ReferralCalculator";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Input } from "../components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogTrigger } from "../components/ui/dialog";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, ReferenceLine } from "recharts";
import { QRCodeCanvas } from "qrcode.react";


function MonthlyRankingCard() {
  const { user } = useAuth();
  const [ranking, setRanking] = useState([]);
  const [prize, setPrize] = useState("");
  const [refCode, setRefCode] = useState("");
  const [hall, setHall] = useState([]);
  useEffect(() => {
    api.get("/me/referral/monthly-ranking").then((r) => { setRanking(r.data.ranking || []); setPrize(r.data.prize || ""); }).catch(() => {});
    api.get("/me/referral").then((r) => setRefCode(r.data.ref_code || "")).catch(() => {});
    api.get("/me/referral/hall-of-fame").then((r) => setHall(r.data || [])).catch(() => {});
  }, []);
  const monthLabel = (m) => {
    const names = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
    const [y, mm] = (m || "").split("-");
    return mm ? `${names[Number(mm) - 1]} ${y}` : m;
  };
  const isFirst = ranking.length > 0 && user && ranking[0].user_id === user.id;
  const wins = user?.ranking_wins || 0;
  const shareFirst = () => {
    const link = refCode ? `${window.location.origin}/register?ref=${refCode}` : window.location.origin;
    const msg = `¡Voy #1 en el ranking de invitadores de Grupo Estrella Hernández Inversiones este mes! 🏆 Únete con mi enlace: ${link}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
  };
  const shareBadge = () => {
    const link = refCode ? `${window.location.origin}/register?ref=${refCode}` : window.location.origin;
    const veces = wins === 1 ? "una vez" : `${wins} veces`;
    const msg = `🏅 ¡He sido Ganador del ranking de invitadores de Grupo Estrella Hernández Inversiones (${veces})! 🏆 Únete tú también con mi enlace: ${link}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
  };
  return (
    <>
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6" data-testid="member-monthly-ranking">
      <h3 className="font-display font-bold text-emerald-900 mb-4">🏆 Top invitadores del mes</h3>
      {wins > 0 && (
        <div className="mb-4 rounded-lg bg-amber-50 border border-amber-200 px-4 py-3" data-testid="member-winner-badge">
          <div className="flex items-center gap-2 text-sm font-semibold text-amber-800">
            🏅 Ganador del ranking · {wins} {wins === 1 ? "vez" : "veces"}
          </div>
          <Button data-testid="share-badge-btn" onClick={shareBadge} size="sm" className="mt-2 bg-green-600 hover:bg-green-700 gap-1.5 h-9">
            <WhatsappLogo size={16} weight="fill" /> Compartir mi insignia
          </Button>
        </div>
      )}
      {prize ? <div className="mb-4 rounded-lg bg-emerald-50 border border-emerald-200 px-4 py-2.5 text-sm font-semibold text-emerald-800" data-testid="member-ranking-prize">🎁 Premio del mes: {prize}</div> : null}
      {ranking.length === 0 ? (
        <p className="text-slate-400 text-sm" data-testid="member-ranking-empty">Sé el primero en invitar este mes. ¡Comparte tu enlace!</p>
      ) : (
        <div className="space-y-2">
          {ranking.map((r, i) => (
            <div key={r.user_id} className={`flex items-center justify-between rounded-lg px-4 py-2.5 ${user && r.user_id === user.id ? "bg-amber-50 border border-amber-200" : "bg-emerald-50/50"}`} data-testid={`member-ranking-row-${i}`}>
              <span className="flex items-center gap-2.5 font-semibold text-emerald-900">
                <span className="text-lg w-6 text-center">{i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : <span className="text-xs text-slate-400">{i + 1}</span>}</span>
                {r.name}{user && r.user_id === user.id ? " (tú)" : ""}
              </span>
              <span className="font-mono-num font-bold text-emerald-700">{r.count}</span>
            </div>
          ))}
        </div>
      )}
      {isFirst && (
        <Button data-testid="share-first-btn" onClick={shareFirst} className="mt-4 w-full bg-green-600 hover:bg-green-700 gap-2">
          <WhatsappLogo size={18} weight="fill" /> Compartir que voy #1 del mes
        </Button>
      )}
    </div>
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 mt-6" data-testid="hall-of-fame">
      <h3 className="font-display font-bold text-emerald-900 mb-4">🏛️ Salón de la Fama</h3>
      {hall.length === 0 ? (
        <p className="text-slate-400 text-sm" data-testid="hall-empty">Aún no hay ganadores de meses anteriores. ¡El próximo puedes ser tú!</p>
      ) : (
        <div className="space-y-2">
          {hall.map((h, i) => (
            <div key={i} className="flex items-center justify-between bg-slate-50 rounded-lg px-4 py-2.5" data-testid={`hall-row-${i}`}>
              <span className="flex items-center gap-2 font-semibold text-emerald-900"><span className="text-lg">🏆</span> {h.name}</span>
              <span className="text-xs text-slate-500 capitalize">{monthLabel(h.month)} · {h.count} ref.</span>
            </div>
          ))}
        </div>
      )}
    </div>
    </>
  );
}

const typeMeta = {
  savings: { icon: PiggyBank, color: "emerald" },
  shares: { icon: ChartLineUp, color: "teal" },
  loan: { icon: HandCoins, color: "amber" },
};

const TransferDialog = ({ account, onDone, beneficiaries = [] }) => {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);
  const [identifier, setIdentifier] = useState("");
  const [amount, setAmount] = useState("");
  const [recipient, setRecipient] = useState(null);
  const [busy, setBusy] = useState(false);
  const benForCur = beneficiaries.filter((b) => b.currency === account.currency);

  useEffect(() => { if (open) { setIdentifier(""); setAmount(""); setRecipient(null); } }, [open]);

  const verify = async () => {
    const v = Number(amount);
    if (!identifier.trim()) { toast.error(t("transfer_need_recipient")); return; }
    if (!v || v <= 0) { toast.error(t("invalid_amount")); return; }
    if (v > account.balance) { toast.error(t("insufficient_funds")); return; }
    setBusy(true);
    try {
      const { data } = await api.get(`/me/transfer/lookup`, { params: { identifier: identifier.trim(), from_account_id: account.id } });
      if (!data.found) { toast.error(t("transfer_recipient_not_found")); setRecipient(null); }
      else setRecipient(data);
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); setRecipient(null); }
    finally { setBusy(false); }
  };

  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/me/transfer`, { from_account_id: account.id, identifier: identifier.trim(), amount: Number(amount) });
      toast.success(`${t("transfer_done")}: ${money(data.amount, data.currency)} → ${data.to_name}`);
      try {
        const res = await api.get(`/me/transfers/${data.transfer_id}/receipt`, { responseType: "blob" });
        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        const a = document.createElement("a");
        a.href = url; a.download = `recibo_${data.reference}.pdf`; document.body.appendChild(a); a.click(); a.remove();
        window.URL.revokeObjectURL(url);
      } catch (_) { /* receipt is best-effort */ }
      setOpen(false); onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid={`transfer-savings-${account.id}`} size="sm" className="mt-4 w-full bg-emerald-800 hover:bg-emerald-900 gap-1.5"><PaperPlaneTilt size={15} weight="bold" /> {t("transfer")}</Button>
      </DialogTrigger>
      <DialogContent data-testid="transfer-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-emerald-900">{t("transfer")} — {account.account_number}</DialogTitle>
          <DialogDescription>{t("current_balance")}: {money(account.balance, account.currency)} · {account.currency}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {account.locked && (
            <div data-testid="transfer-lock-warn" className="flex items-start gap-2 text-xs bg-amber-50 border border-amber-200 text-amber-800 rounded-lg px-3 py-2">
              <LockKey size={16} weight="fill" className="mt-0.5 shrink-0" />
              <span>{t("locked_until")} <b>{dateFmt(account.unlock_date, lang)}</b>. {t("lock_penalty_note")} {account.early_penalty_pct}%.</span>
            </div>
          )}
          {benForCur.length > 0 && (
            <div>
              <Label>Beneficiario guardado</Label>
              <select data-testid="transfer-beneficiary-select" className="mt-1 h-11 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-emerald-600" value={identifier} onChange={(e) => { setIdentifier(e.target.value); setRecipient(null); }}>
                <option value="">— Escribir manualmente —</option>
                {benForCur.map((b) => (<option key={b.id} value={b.account_number}>{(b.alias ? b.alias + " · " : "") + b.holder_name + " (" + b.account_number + ")"}</option>))}
              </select>
            </div>
          )}
          <div>
            <Label>{t("transfer_recipient")}</Label>
            <Input data-testid="transfer-identifier" className="mt-1 h-11" placeholder={t("transfer_recipient_ph")} value={identifier} onChange={(e) => { setIdentifier(e.target.value); setRecipient(null); }} />
          </div>
          <div>
            <Label>{t("mv_amount")} ({account.currency})</Label>
            <Input data-testid="transfer-amount" type="number" step="0.01" min="0" className="mt-1 h-11 font-mono-num" value={amount} onChange={(e) => { setAmount(e.target.value); setRecipient(null); }} />
          </div>
          {recipient && (
            <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-4" data-testid="transfer-confirm-box">
              <p className="text-sm text-emerald-800">{t("transfer_to")}: <b data-testid="transfer-recipient-name">{recipient.holder_name}</b></p>
              <p className="text-xs text-emerald-600 font-mono-num mt-0.5">{recipient.account_number}</p>
              <p className="text-sm text-emerald-900 mt-2">{t("transfer_amount_label")}: <b data-testid="transfer-confirm-amount" className="font-mono-num">{money(Number(amount), account.currency)}</b></p>
            </div>
          )}
        </div>
        <DialogFooter>
          {!recipient ? (
            <Button data-testid="transfer-verify-btn" onClick={verify} disabled={busy} className="bg-emerald-800 hover:bg-emerald-900">{busy ? t("loading") : t("transfer_continue")}</Button>
          ) : (
            <Button data-testid="transfer-confirm-btn" onClick={confirm} disabled={busy} className="bg-emerald-800 hover:bg-emerald-900 gap-1.5"><PaperPlaneTilt size={15} weight="bold" /> {busy ? t("loading") : t("transfer_confirm")}</Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

function HomeCarousel({ onNavigate }) {
  const { t } = useI18n();
  const BACKEND = process.env.REACT_APP_BACKEND_URL;
  const [slides, setSlides] = useState([]);
  const [anns, setAnns] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/me/home-content").then((r) => { setSlides(r.data.slides || []); setAnns(r.data.announcements || []); }).catch(() => {});
  }, []);

  useEffect(() => {
    if (slides.length <= 1) return;
    const id = setInterval(() => setIdx((p) => (p + 1) % slides.length), 6000);
    return () => clearInterval(id);
  }, [slides.length]);

  if (slides.length === 0 && anns.length === 0) return null;
  const cur = slides.length ? slides[Math.min(idx, slides.length - 1)] : null;
  const go = (d) => setIdx((p) => (p + d + slides.length) % slides.length);

  return (
    <div className="mt-6 space-y-4" data-testid="home-carousel">
      {cur && (
        <div className="relative rounded-2xl overflow-hidden border border-emerald-100 shadow-sm bg-emerald-900 min-h-[240px]">
          {cur.image_url && <img src={`${BACKEND}${cur.image_url}`} alt={cur.title} className="w-full h-56 sm:h-72 object-cover opacity-90" data-testid="carousel-active-image" />}
          <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/85 via-emerald-900/30 to-transparent" />
          <div className="absolute inset-0 flex flex-col justify-end px-14 py-6">
            {cur.title && <h3 className="font-display font-bold text-white text-2xl" data-testid="carousel-active-title">{cur.title}</h3>}
            {cur.text && <p className="text-emerald-50/90 text-sm mt-1 max-w-2xl">{cur.text}</p>}
            {cur.person_name && <p className="text-emerald-200/80 text-xs mt-1">— {cur.person_name}</p>}
            {cur.button_text && cur.button_target === "eventos" && (
              <button onClick={() => onNavigate && onNavigate("calendario")} data-testid="carousel-active-btn" className="mt-3 inline-flex w-fit items-center gap-1.5 h-9 px-4 rounded-full bg-white text-emerald-900 text-sm font-semibold hover:bg-emerald-50 transition-colors">
                {cur.button_text}
              </button>
            )}
            {cur.button_text && cur.button_target !== "eventos" && cur.button_link && (
              <a href={cur.button_link} target="_blank" rel="noreferrer" data-testid="carousel-active-btn" className="mt-3 inline-flex w-fit items-center gap-1.5 h-9 px-4 rounded-full bg-white text-emerald-900 text-sm font-semibold hover:bg-emerald-50 transition-colors">
                {cur.button_text}
              </a>
            )}
          </div>
          {slides.length > 1 && (
            <>
              <button onClick={() => go(-1)} data-testid="carousel-prev" className="absolute left-3 top-1/2 -translate-y-1/2 h-9 w-9 rounded-full bg-white/85 text-emerald-900 flex items-center justify-center hover:bg-white"><CaretLeft size={18} weight="bold" /></button>
              <button onClick={() => go(1)} data-testid="carousel-next" className="absolute right-3 top-1/2 -translate-y-1/2 h-9 w-9 rounded-full bg-white/85 text-emerald-900 flex items-center justify-center hover:bg-white"><CaretRight size={18} weight="bold" /></button>
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
                {slides.map((_, i) => <button key={i} onClick={() => setIdx(i)} className={`h-2 rounded-full transition-all ${i === idx ? "w-5 bg-white" : "w-2 bg-white/50"}`} data-testid={`carousel-dot-${i}`} />)}
              </div>
            </>
          )}
        </div>
      )}

      {anns.length > 0 && (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-5" data-testid="home-announcements">
          <h4 className="font-display font-bold text-emerald-900 flex items-center gap-2 mb-3"><Megaphone size={18} weight="duotone" /> {t("news_for_you")}</h4>
          <div className="space-y-3">
            {anns.map((a, i) => (
              <div key={i} className="border-l-2 border-emerald-500 pl-3" data-testid={`home-ann-${i}`}>
                {a.title && <p className="font-semibold text-emerald-900 text-sm">{a.title}</p>}
                {a.text && <p className="text-slate-600 text-sm">{a.text}</p>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function TeamView() {
  const { t } = useI18n();
  const BACKEND = process.env.REACT_APP_BACKEND_URL;
  const [members, setMembers] = useState([]);
  useEffect(() => { api.get("/me/team").then((r) => setMembers(r.data.members || [])).catch(() => {}); }, []);
  return (
    <div className="mt-8" data-testid="team-view">
      <div className="flex items-center gap-2 mb-5">
        <Users size={22} weight="duotone" className="text-emerald-700" />
        <h2 className="font-display font-bold text-emerald-900 text-xl">{t("team_tab")}</h2>
      </div>
      {members.length === 0 ? (
        <p className="text-slate-400 text-center py-10" data-testid="team-view-empty">{t("no_team")}</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="team-view-list">
          {members.map((m, i) => {
            const initials = (m.name || "?").split(" ").filter(Boolean).slice(0, 2).map((s) => s[0]).join("").toUpperCase();
            const photo = m.photo_url ? `${BACKEND}${m.photo_url}` : null;
            return (
              <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 flex flex-col items-center text-center" data-testid={`team-view-member-${i}`}>
                {photo ? <img src={photo} alt={m.name} className="h-24 w-24 rounded-full object-cover border-2 border-emerald-100" /> : <div className="h-24 w-24 rounded-full bg-emerald-100 text-emerald-800 flex items-center justify-center font-bold text-2xl">{initials || "?"}</div>}
                <p className="font-display font-bold text-emerald-900 mt-3">{m.name}</p>
                {m.role && <p className="text-sm text-emerald-600 font-semibold mt-0.5">{m.role}</p>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function ClientDashboard() {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const [accounts, setAccounts] = useState([]);
  const [txs, setTxs] = useState([]);
  const [termDeposits, setTermDeposits] = useState([]);
  const [exchange, setExchange] = useState(60);
  const [goal, setGoal] = useState(0);
  const [goalInput, setGoalInput] = useState("");
  const [referral, setReferral] = useState(null);
  const [savingsAccts, setSavingsAccts] = useState([]);
  const [myLoans, setMyLoans] = useState([]);
  const [transfers, setTransfers] = useState([]);
  const [transferSearch, setTransferSearch] = useState("");
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [benIdentifier, setBenIdentifier] = useState("");
  const [benAlias, setBenAlias] = useState("");
  const [benBusy, setBenBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = () => {
    Promise.all([api.get("/me/accounts"), api.get("/me/transactions"), api.get("/me/term-deposits"), api.get("/rates"), api.get("/me/goal"), api.get("/me/referral"), api.get("/me/savings-accounts"), api.get("/me/loan-records"), api.get("/me/transfers"), api.get("/me/beneficiaries")])
      .then(([a, b, c, d, g, r, sv, ln, tr, be]) => { setAccounts(a.data); setTxs(b.data); setTermDeposits(c.data); setExchange(d.data.exchange_rate || 60); setGoal(g.data.goal || 0); setGoalInput(g.data.goal ? String(g.data.goal) : ""); setReferral(r.data); setSavingsAccts(sv.data); setMyLoans(ln.data); setTransfers(tr.data); setBeneficiaries(be.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  const addBeneficiary = async () => {
    if (!benIdentifier.trim()) { toast.error("Indica el dato del beneficiario"); return; }
    setBenBusy(true);
    try {
      await api.post("/me/beneficiaries", { identifier: benIdentifier.trim(), alias: benAlias.trim() });
      setBenIdentifier(""); setBenAlias("");
      const r = await api.get("/me/beneficiaries"); setBeneficiaries(r.data);
      toast.success("Beneficiario agregado");
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    finally { setBenBusy(false); }
  };
  const removeBeneficiary = async (id) => {
    try { await api.delete(`/me/beneficiaries/${id}`); setBeneficiaries((prev) => prev.filter((b) => b.id !== id)); toast.success("Beneficiario eliminado"); }
    catch (e) { toast.error("Error"); }
  };

  const downloadTransferReceipt = async (tid, ref) => {
    try {
      const res = await api.get(`/me/transfers/${tid}/receipt`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = `recibo_${ref}.pdf`; document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) { toast.error("Error"); }
  };

  const joinReferral = async () => {
    try { await api.post("/me/referral/join"); toast.success("OK"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  const copyRefLink = async () => {
    const link = `${window.location.origin}/register?ref=${referral?.ref_code}`;
    try {
      await navigator.clipboard.writeText(link);
      toast.success(t("copied"));
    } catch (e) {
      toast.error(link);
    }
  };

  const saveGoal = async () => {
    try {
      const { data } = await api.put("/me/goal", { goal: Number(goalInput) || 0 });
      setGoal(data.goal);
      toast.success(t("goal_saved"));
    } catch (e) { toast.error("Error"); }
  };

  useEffect(() => {
    load();
    const id = setInterval(() => api.get("/me/accounts").then((r) => setAccounts(r.data)), 5000);
    return () => clearInterval(id);
  }, []);

  const savings = accounts.filter((a) => a.type !== "loan");
  const loans = accounts.filter((a) => a.type === "loan");

  const approxOther = (amount, currency) => {
    const rate = Number(exchange) || 0;
    if (!rate) return null;
    if (currency === "USD") return money(amount * rate, "DOP");
    return money(amount / rate, "USD");
  };

  const toDop = (amount, currency) => (currency === "USD" ? amount * (Number(exchange) || 0) : amount);
  const growthData = (() => {
    if (savings.length === 0 && termDeposits.length === 0) return [];
    const pts = [];
    for (let m = 0; m <= 12; m++) {
      let total = 0;
      savings.forEach((a) => { total += toDop(a.balance, a.currency) * (1 + (a.rate || 0) / 100 * (m / 12)); });
      termDeposits.forEach((d) => { total += toDop(d.principal, d.currency) * (1 + (d.annual_rate || 0) / 100 * (m / 12)); });
      pts.push({ mLabel: `${m}`, value: Math.round(total) });
    }
    return pts;
  })();

  const navItems = [
    { key: "cuentas", label: "nav_accounts", icon: House },
    { key: "actividades", label: "activity_tab", icon: ClockCounterClockwise },
    { key: "solicitar", label: "loan_request_tab", icon: HandCoins },
    { key: "plazo", label: "my_term_deposits", icon: Vault },
    { key: "tienda", label: "Tienda", icon: Gift },
    { key: "transferencias", label: "transfers_tab", icon: PaperPlaneTilt },
    { key: "envios", label: "remittances_tab", icon: PaperPlaneTilt },
    { key: "boletos", label: "raffle_tab", icon: Ticket },
    { key: "calendario", label: "calendar_tab", icon: CalendarCheck },
    { key: "equipo", label: "team_tab", icon: Users },
    { key: "documentos", label: "my_documents_tab", icon: IdentificationCard },
    { key: "referidos", label: "referral_tab", icon: ShareNetwork },
    { key: "movimientos", label: "nav_activity", icon: ClockCounterClockwise },
    { key: "estado", label: "nav_statement", icon: FilePdf },
  ];
  const [section, setSection] = useState("cuentas");
  const [qrOpen, setQrOpen] = useState(false);
  const refLink = referral ? `${window.location.origin}/register?ref=${referral.ref_code}` : "";
  const downloadQr = () => {
    const canvas = document.querySelector("#referral-qr-canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `mi-enlace-referido-${referral?.ref_code || ""}.png`;
    document.body.appendChild(a); a.click(); a.remove();
  };
  const downloadCard = async () => {
    try {
      const res = await api.get("/me/referral/card", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = `tarjeta-referido-${referral?.ref_code || ""}.pdf`;
      document.body.appendChild(a); a.click(); a.remove(); window.URL.revokeObjectURL(url);
    } catch (e) { toast.error("No se pudo generar la tarjeta"); }
  };
  const [downloading, setDownloading] = useState(false);

  const downloadStatement = async () => {
    setDownloading(true);
    try {
      const res = await api.get("/me/statement", { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = "estado_de_cuenta.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Error");
    } finally {
      setDownloading(false);
    }
  };

  const downloadReceipt = async (txId) => {
    try {
      const res = await api.get(`/receipt/${txId}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `recibo_${txId.slice(0, 8)}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Error");
    }
  };

  const downloadMyLoanCert = async (l) => {
    try {
      const res = await api.get(`/me/loan-records/${l.id}/certificate`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `certificado_prestamo_${l.loan_number}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Error");
    }
  };

  const downloadSavingsCert = async (s) => {
    try {
      const res = await api.get(`/me/savings-accounts/${s.id}/certificate`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `certificado_ahorro_${s.account_number}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Error");
    }
  };

  const downloadTermCert = async (d) => {
    try {
      const res = await api.get(`/me/term-deposits/${d.id}/certificate`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `certificado_${d.account_number}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Error");
    }
  };

  return (
    <div className="App bg-[#F8FAFC] min-h-screen">
      <Header />
      <OnboardingModal onNavigate={setSection} />
      <Dialog open={qrOpen} onOpenChange={setQrOpen}>
        <DialogContent data-testid="referral-qr-dialog" className="max-w-xs">
          <DialogHeader>
            <DialogTitle className="font-display text-emerald-900 flex items-center gap-2"><QrCode size={20} weight="duotone" /> Tu código QR</DialogTitle>
            <DialogDescription>Escanéalo para abrir tu enlace de referido. Compártelo o imprímelo.</DialogDescription>
          </DialogHeader>
          <div className="flex flex-col items-center gap-4 py-2">
            <div className="bg-white p-4 rounded-xl border border-emerald-100 shadow-sm">
              {refLink && <QRCodeCanvas id="referral-qr-canvas" value={refLink} size={200} level="M" includeMargin fgColor="#0B2545" />}
            </div>
            <p className="text-xs text-slate-400 font-mono-num break-all text-center">{refLink}</p>
            <Button data-testid="referral-qr-download" onClick={downloadQr} className="w-full bg-emerald-800 hover:bg-emerald-900 gap-1.5"><FilePdf size={16} weight="bold" /> Descargar PNG</Button>
            <Button data-testid="referral-card-download" onClick={downloadCard} variant="outline" className="w-full border-emerald-300 text-emerald-800 hover:bg-emerald-50 gap-1.5"><IdentificationCard size={16} weight="bold" /> Descargar tarjeta imprimible</Button>
          </div>
        </DialogContent>
      </Dialog>
      <DashboardNav items={navItems} active={section} onChange={setSection} />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="font-display text-3xl font-bold text-emerald-900" data-testid="dashboard-title">
            {t("hello")}, {user?.name} 👋
          </h1>
          <p className="text-slate-500 mt-1">{t(navItems.find((n) => n.key === section)?.label)}</p>
        </motion.div>

        {/* CUENTAS */}
        {section === "cuentas" && (
        <>
        <HomeCarousel onNavigate={setSection} />
        <div className="mt-6 bg-white rounded-xl border border-gray-100 shadow-sm p-6 flex items-center gap-4" data-testid="profile-card">
          <div className="h-14 w-14 rounded-full bg-emerald-100 flex items-center justify-center">
            <User size={28} weight="duotone" className="text-emerald-800" />
          </div>
          <div className="text-sm">
            <p className="font-semibold text-emerald-900 text-base">{user?.name}</p>
            {user?.email && <p className="text-slate-500">{user.email}</p>}
            {user?.phone && <p className="text-slate-500">{user.phone}</p>}
          </div>
        </div>
        {referral && (
          <div className="mt-6 bg-emerald-800 rounded-xl shadow-sm p-5 text-white" data-testid="referral-widget">
            <div className="flex items-center gap-2 mb-3">
              <ShareNetwork size={20} weight="duotone" className="text-emerald-200" />
              <p className="font-display font-bold text-base">Invita y gana</p>
            </div>
            <p className="text-emerald-100 text-sm mb-3">Comparte tu enlace y gana bonos y descuentos por cada socio que se una.</p>
            {referral.tier_progress?.enabled && (
              <div data-testid="ref-goal" className="mb-4 bg-emerald-900/40 rounded-lg p-3 border border-emerald-600">
                <div className="flex items-center justify-between text-xs mb-1.5">
                  <span className="font-semibold text-emerald-100">{t("ref_goal_title")}</span>
                  <span className="text-emerald-200">{referral.tier_progress.active} {t("ref_active_refs")}</span>
                </div>
                {referral.tier_progress.max_reached ? (
                  <p className="text-sm font-semibold text-amber-300">{t("ref_goal_max")} · {referral.tier_progress.current_pct}% {t("ref_goal_disc")}</p>
                ) : (
                  <>
                    <div className="h-2.5 rounded-full bg-emerald-950 overflow-hidden">
                      <div className="h-full bg-amber-400 rounded-full transition-all" style={{ width: `${Math.min(100, Math.round((referral.tier_progress.active / (referral.tier_progress.next_min || 1)) * 100))}%` }} />
                    </div>
                    <p className="text-xs text-emerald-100 mt-1.5">{t("ref_goal_remaining_pre")} <b className="text-white">{referral.tier_progress.remaining}</b> {t("ref_referrals_word")} {t("ref_goal_next_lvl")} (<b className="text-amber-300">{referral.tier_progress.next_pct}%</b> {t("ref_goal_disc")})</p>
                    <button
                      type="button"
                      data-testid="ref-goal-share-btn"
                      onClick={() => {
                        const link = `${window.location.origin}/register?ref=${referral.ref_code}`;
                        const n = referral.tier_progress.remaining;
                        const falta = n === 1 ? "me falta solo 1 referido" : `me faltan solo ${n} referidos`;
                        const msg = `¡En Grupo Estrella Hernández Inversiones ${falta} para subir de nivel y obtener ${referral.tier_progress.next_pct}% de descuento! Únete con mi enlace y crezcamos juntos: ${link}`;
                        window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
                      }}
                      className="mt-2.5 inline-flex items-center justify-center gap-1.5 h-9 px-3 rounded-md bg-green-500 hover:bg-green-600 text-white text-xs font-semibold transition-colors"
                    >
                      <WhatsappLogo size={16} weight="fill" /> Compartir mi meta
                    </button>
                  </>
                )}
              </div>
            )}
            <div className="flex flex-wrap items-center gap-2">
              <input readOnly data-testid="referral-widget-input" value={`${window.location.origin}/register?ref=${referral.ref_code}`} className="flex-1 min-w-0 basis-full sm:basis-0 h-11 rounded-md border border-emerald-600 px-3 font-mono-num text-sm bg-emerald-900/40 text-emerald-50" />
              <Button data-testid="referral-widget-copy" onClick={copyRefLink} className="flex-1 sm:flex-none h-11 bg-white text-emerald-900 hover:bg-emerald-50 gap-1.5"><Copy size={16} weight="bold" /> {t("copy")}</Button>
              <a data-testid="referral-widget-whatsapp" href={`https://wa.me/?text=${encodeURIComponent(`¡Únete a Grupo Estrella Hernández Inversiones con mi enlace y empecemos a ahorrar juntos! ${window.location.origin}/register?ref=${referral.ref_code}`)}`} target="_blank" rel="noopener noreferrer" className="flex-1 sm:flex-none inline-flex items-center justify-center gap-1.5 h-11 px-4 rounded-md bg-green-500 hover:bg-green-600 font-semibold transition-colors"><WhatsappLogo size={18} weight="fill" /> WhatsApp</a>
              <Button data-testid="referral-widget-qr" onClick={() => setQrOpen(true)} className="flex-1 sm:flex-none h-11 bg-emerald-700 hover:bg-emerald-600 border border-emerald-500 gap-1.5"><QrCode size={18} weight="bold" /> QR</Button>
            </div>
          </div>
        )}

        {loading ? (
          <p className="mt-10 text-slate-500">{t("loading")}</p>
        ) : (accounts.length === 0 && savingsAccts.length === 0 && myLoans.length === 0 && termDeposits.length === 0) ? (
          <div className="mt-8 bg-white rounded-xl border border-dashed border-gray-300 p-10 text-center text-slate-500" data-testid="no-accounts">
            {t("no_accounts")}
          </div>
        ) : (
          <>
            {savings.length > 0 && (
            <div className="mt-8 grid md:grid-cols-2 gap-5">
              {savings.map((acc) => {
                const M = typeMeta[acc.type];
                return (
                  <motion.div
                    key={acc.id}
                    initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
                    className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 hover:shadow-md transition-all"
                    data-testid={`account-card-${acc.type}`}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-2.5">
                        <div className="h-10 w-10 rounded-lg bg-emerald-100 flex items-center justify-center">
                          <M.icon size={22} weight="duotone" className="text-emerald-800" />
                        </div>
                        <span className="font-display font-bold text-emerald-900 text-lg">{t(acc.type)}</span>
                      </div>
                      <span className="text-xs font-mono-num bg-emerald-50 text-emerald-700 px-2.5 py-1 rounded-full font-semibold">
                        {acc.rate}% · {acc.currency === "USD" ? "USD" : "RD$"}
                      </span>
                    </div>
                    <p className="text-xs uppercase tracking-wider text-slate-400">{t("current_balance")}</p>
                    <p className="font-mono-num text-3xl font-bold text-emerald-900">{money(acc.balance, acc.currency)}</p>
                    {approxOther(acc.balance, acc.currency) && (
                      <p className="text-xs text-slate-400 font-mono-num mt-0.5" data-testid={`approx-${acc.type}`}>≈ {approxOther(acc.balance, acc.currency)} <span className="lowercase">({t("approx")})</span></p>
                    )}
                    <div className="mt-4 flex items-center gap-2 text-emerald-700 bg-emerald-50 rounded-lg px-3 py-2">
                      <TrendUp size={18} weight="bold" />
                      <span className="text-sm">{t("accrued_earnings")}:</span>
                      <span className="font-mono-num font-bold ml-auto" data-testid={`earnings-${acc.type}`}>{money(acc.earnings, acc.currency)}</span>
                    </div>
                  </motion.div>
                );
              })}
            </div>
            )}

            {loans.length > 0 && (
              <div className="mt-8 space-y-5">
                {loans.map((loan) => (                  <div key={loan.id} className="bg-white rounded-xl border border-gray-100 shadow-sm p-6" data-testid="loan-card">
                    <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
                      <div className="flex items-center gap-2.5">
                        <div className="h-10 w-10 rounded-lg bg-amber-100 flex items-center justify-center">
                          <HandCoins size={22} weight="duotone" className="text-amber-700" />
                        </div>
                        <span className="font-display font-bold text-emerald-900 text-lg">{t("loan")}</span>
                      </div>
                      <div className="flex gap-6 text-sm flex-wrap">
                        <div><p className="text-slate-400 text-xs">{t("principal_amount")}</p><p className="font-mono-num font-bold text-emerald-900">{money(loan.principal, loan.currency)}</p></div>
                        <div><p className="text-slate-400 text-xs">{t("remaining_balance")}</p><p className="font-mono-num font-bold text-amber-700">{money(loan.remaining_balance, loan.currency)}</p></div>
                        <div><p className="text-slate-400 text-xs">{t("monthly_payment")}</p><p className="font-mono-num font-bold text-emerald-900">{money(loan.monthly_payment, loan.currency)}</p></div>
                        <div><p className="text-slate-400 text-xs">{t("annual_rate")}</p><p className="font-mono-num font-bold text-emerald-900">{loan.annual_rate}%</p></div>
                      </div>
                    </div>
                    {loan.next_due_date && (
                      <div className="mb-4 flex items-center gap-2 text-sm bg-amber-50 border border-amber-200 text-amber-800 rounded-lg px-3 py-2" data-testid="loan-due-notice">
                        <span className="font-semibold">{t("next_due")}:</span>
                        <span className="font-mono-num">{money(loan.next_due_amount, loan.currency)}</span>
                        <span className="text-amber-600">· {dateFmt(loan.next_due_date, lang)}</span>
                      </div>
                    )}
                    <div className="max-h-56 overflow-y-auto rounded-lg border border-gray-100">
                      <table className="w-full text-sm font-mono-num">
                        <thead className="bg-emerald-50 text-emerald-800 sticky top-0">
                          <tr>
                            <th className="px-3 py-2 text-left">{t("period")}</th>
                            <th className="px-3 py-2 text-right">{t("payment")}</th>
                            <th className="px-3 py-2 text-right">{t("principal")}</th>
                            <th className="px-3 py-2 text-right">{t("interest")}</th>
                            <th className="px-3 py-2 text-right">{t("balance")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loan.schedule.map((r) => (
                            <tr key={r.period} className="border-t border-gray-100">
                              <td className="px-3 py-1.5 text-slate-400">{r.period}</td>
                              <td className="px-3 py-1.5 text-right">{money(r.payment, loan.currency)}</td>
                              <td className="px-3 py-1.5 text-right text-emerald-700">{money(r.principal, loan.currency)}</td>
                              <td className="px-3 py-1.5 text-right text-amber-600">{money(r.interest, loan.currency)}</td>
                              <td className="px-3 py-1.5 text-right">{money(r.balance, loan.currency)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {savingsAccts.length > 0 && (
            <div className="mt-8" data-testid="my-savings-accounts">
              <h2 className="font-display font-bold text-emerald-900 text-xl mb-4">{t("savings_accounts")}</h2>
              <div className="grid md:grid-cols-2 gap-5">
                {savingsAccts.map((s) => (
                  <div key={s.id} className="bg-white rounded-xl border border-gray-100 shadow-sm p-6" data-testid={`my-savings-${s.id}`}>
                    <div className="flex items-center gap-2.5 mb-3">
                      <div className="h-10 w-10 rounded-lg bg-emerald-100 flex items-center justify-center"><PiggyBank size={22} weight="duotone" className="text-emerald-800" /></div>
                      <div>
                        <p className="font-display font-bold text-emerald-900 leading-none">{t("savings_tab")}</p>
                        <p className="font-mono-num text-xs text-emerald-600 mt-1">{s.account_number}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-3 text-sm">
                      <div><p className="text-slate-400 text-xs">{t("current_balance")}</p><p data-testid={`savings-balance-${s.id}`} className="font-mono-num font-bold text-emerald-900">{money(s.balance, s.currency)}</p></div>
                      <div><p className="text-slate-400 text-xs">{t("accrued_earnings")}</p><p data-testid={`savings-earnings-${s.id}`} className="font-mono-num font-bold text-emerald-700">{money(s.earnings, s.currency)}</p></div>
                      <div><p className="text-slate-400 text-xs">{t("accrued_rate")}</p><p className="font-mono-num font-semibold text-emerald-900">{Number(s.rate || 0).toFixed(2)}%</p></div>
                      <div><p className="text-slate-400 text-xs">{t("holder")}</p><p className="font-semibold text-emerald-900">{s.full_name}</p></div>
                    </div>
                    {s.locked && (
                      <div data-testid={`savings-lock-${s.id}`} className="mt-3 flex items-start gap-2 text-xs bg-amber-50 border border-amber-200 text-amber-800 rounded-lg px-3 py-2">
                        <LockKey size={16} weight="fill" className="mt-0.5 shrink-0" />
                        <span>{t("locked_until")} <b>{dateFmt(s.unlock_date, lang)}</b>. {t("lock_penalty_note")} {s.early_penalty_pct}%.</span>
                      </div>
                    )}
                    <Button data-testid={`cert-savings-${s.id}`} onClick={() => downloadSavingsCert(s)} size="sm" variant="outline" className="mt-4 w-full border-emerald-300 text-emerald-800 hover:bg-emerald-50 gap-1.5"><FilePdf size={15} weight="bold" /> {t("certificate")}</Button>
                    <TransferDialog account={s} onDone={load} beneficiaries={beneficiaries} />
                  </div>
                ))}
              </div>
            </div>
            )}
            {myLoans.length > 0 && (
            <div className="mt-8" data-testid="my-loans">
              <h2 className="font-display font-bold text-emerald-900 text-xl mb-4">{t("my_loans")}</h2>
              <div className="grid md:grid-cols-2 gap-5">
                {myLoans.map((l) => (
                  <MyLoanCard key={l.id} l={l} onCert={downloadMyLoanCert} />
                ))}
              </div>
            </div>
            )}
          </>
        )}

        {!loading && growthData.length > 0 && (
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="mt-8 bg-white rounded-xl border border-gray-100 shadow-sm p-6" data-testid="growth-chart-card">
            <div className="flex items-center gap-2.5 mb-1">
              <div className="h-10 w-10 rounded-lg bg-emerald-100 flex items-center justify-center">
                <ChartIcon size={22} weight="duotone" className="text-emerald-800" />
              </div>
              <h2 className="font-display font-bold text-emerald-900 text-lg">{t("growth_title")}</h2>
            </div>
            <p className="text-sm text-slate-500 mb-4">{t("growth_sub")}</p>
            <div className="flex items-end gap-2 mb-4 max-w-sm">
              <div className="flex-1">
                <label className="text-xs font-semibold text-emerald-900">{t("savings_goal")}</label>
                <input data-testid="goal-input" type="number" className="mt-1 w-full h-10 rounded-md border border-emerald-200 px-3 font-mono-num text-sm focus:outline-none focus:ring-2 focus:ring-emerald-300" value={goalInput} onChange={(e) => setGoalInput(e.target.value)} />
              </div>
              <Button data-testid="goal-save-btn" onClick={saveGoal} size="sm" className="h-10 bg-emerald-800 hover:bg-emerald-900">{t("set_goal")}</Button>
            </div>
            {goal > 0 && growthData.length > 0 && (
              <div className="mb-4 max-w-sm" data-testid="goal-progress">
                <div className="flex justify-between text-xs mb-1.5">
                  <span className="font-semibold text-emerald-900">{t("goal_progress")}</span>
                  <span className="font-mono-num text-emerald-700">{Math.min(100, Math.round((growthData[0].value / goal) * 100))}% {t("of_goal")}</span>
                </div>
                <div className="h-2.5 w-full rounded-full bg-emerald-100 overflow-hidden">
                  <div className="h-full rounded-full bg-emerald-600 transition-all" style={{ width: `${Math.min(100, (growthData[0].value / goal) * 100)}%` }} />
                </div>
              </div>
            )}
            <div className="h-64 w-full min-w-0">
              <ResponsiveContainer width="100%" height="100%" minWidth={0}>
                <AreaChart data={growthData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                  <defs>
                    <linearGradient id="growthFill" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#2c4a7e" stopOpacity={0.35} />
                      <stop offset="100%" stopColor="#2c4a7e" stopOpacity={0.02} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
                  <XAxis dataKey="mLabel" tick={{ fontSize: 12, fill: "#94a3b8" }} tickLine={false} axisLine={false} />
                  <YAxis tick={{ fontSize: 11, fill: "#94a3b8" }} tickLine={false} axisLine={false} width={70} domain={[0, (dataMax) => Math.ceil(Math.max(dataMax, goal || 0) * 1.05)]} tickFormatter={(v) => `RD$${(v / 1000).toFixed(0)}k`} />
                  <Tooltip formatter={(v) => [money(v, "DOP"), t("projected_value")]} labelFormatter={(l) => `${l} ${lang === "es" ? "meses" : "months"}`} />
                  {goal > 0 && <ReferenceLine y={goal} stroke="#d97706" strokeDasharray="5 4" ifOverflow="extendDomain" label={{ value: `${t("goal_line")}: ${money(goal, "DOP")}`, position: "insideTopRight", fill: "#b45309", fontSize: 11 }} />}
                  <Area type="monotone" dataKey="value" stroke="#0b2545" strokeWidth={2.5} fill="url(#growthFill)" />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </motion.div>
        )}
        </>
        )}

        {section === "cuentas" && <MemberTestimonialCard />}

        {/* MOVIMIENTOS */}
        {section === "movimientos" && (        <div className="mt-8 bg-white rounded-xl border border-gray-100 shadow-sm p-6">
          <h2 className="font-display font-bold text-emerald-900 text-xl mb-4">{t("recent_activity")}</h2>
          {txs.length === 0 ? (
            <p className="text-slate-500 text-sm">{t("no_activity")}</p>
          ) : (
            <div className="divide-y divide-gray-100">
              {txs.map((tx) => {
                const isDeposit = tx.type === "deposit" || tx.type === "transfer_in" || tx.type === "referral";
                return (
                <div key={tx.id} className="flex items-center justify-between py-3" data-testid="tx-row">
                  <div className="flex items-center gap-3">
                    <span className={`h-9 w-9 rounded-full flex items-center justify-center ${isDeposit ? "bg-emerald-100 text-emerald-700" : tx.type === "loan_payment" ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-600"}`}>
                      {isDeposit ? "+" : "−"}
                    </span>
                    <div>
                      <p className="font-semibold text-emerald-900">{t(tx.type)}</p>
                      <p className="text-xs text-slate-400">{dateFmt(tx.created_at, lang)}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className={`font-mono-num font-bold ${isDeposit ? "text-emerald-700" : tx.type === "loan_payment" ? "text-amber-700" : "text-red-600"}`}>
                      {isDeposit ? "+" : "−"}{money(tx.amount, tx.currency)}
                    </span>
                    {tx.type === "loan_payment" && (
                      <Button data-testid={`receipt-btn-${tx.id}`} size="sm" variant="outline" onClick={() => downloadReceipt(tx.id)} className="border-emerald-300 text-emerald-800 hover:bg-emerald-50 gap-1 h-8">
                        <FilePdf size={14} weight="bold" /> {t("receipt")}
                      </Button>
                    )}
                  </div>
                </div>
              );})}
            </div>
          )}
        </div>
        )}

        {/* DEPÓSITOS A PLAZO */}
        {section === "plazo" && (
        <div className="mt-8">
          <h2 className="font-display font-bold text-emerald-900 text-xl mb-4">{t("my_term_deposits")}</h2>
          <div className="mb-4 flex items-start gap-2.5 rounded-xl border border-amber-200 bg-amber-50 p-4" data-testid="td-notice">
            <ClockCounterClockwise size={20} weight="duotone" className="text-amber-700 shrink-0 mt-0.5" />
            <p className="text-sm text-amber-800 leading-relaxed">{t("td_notice")}</p>
          </div>
          {termDeposits.length === 0 ? (
            <div className="bg-white rounded-xl border border-dashed border-gray-300 p-10 text-center text-slate-500" data-testid="no-my-deposits">{t("no_my_deposits")}</div>
          ) : (
            <div className="grid md:grid-cols-2 gap-5" data-testid="my-term-deposits">
              {termDeposits.map((d) => (
                <div key={d.id} className="bg-white rounded-xl border border-gray-100 shadow-sm p-6" data-testid={`my-term-${d.id}`}>
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2.5">
                      <div className="h-10 w-10 rounded-lg bg-emerald-100 flex items-center justify-center"><Vault size={22} weight="duotone" className="text-emerald-800" /></div>
                      <div>
                        <p className="font-display font-bold text-emerald-900 leading-none">{t("term_deposits")}</p>
                        <p className="font-mono-num text-xs text-emerald-600 mt-1">{d.account_number}</p>
                      </div>
                    </div>
                    <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${d.matured ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{d.matured ? t("matured") : t("active_term")}</span>
                  </div>
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div><p className="text-slate-400 text-xs">{t("deposit_amount")}</p><p className="font-mono-num font-bold text-emerald-900">{money(d.principal, d.currency)} · {d.annual_rate}%</p></div>
                    <div><p className="text-slate-400 text-xs">{t("accrued_interest")}</p><p className="font-mono-num font-bold text-emerald-700">{money(d.accrued_interest, d.currency)}</p></div>
                    <div><p className="text-slate-400 text-xs">{t("current_value")}</p><p className="font-mono-num font-bold text-emerald-900">{money(d.current_value, d.currency)}</p></div>
                    <div><p className="text-slate-400 text-xs">{t("maturity")}</p><p className="font-mono-num font-bold text-emerald-900">{dateFmt(d.end_date, lang)}</p></div>
                  </div>
                  <Button data-testid={`my-cert-${d.id}`} size="sm" variant="outline" onClick={() => downloadTermCert(d)} className="mt-4 border-emerald-300 text-emerald-800 hover:bg-emerald-50 gap-1.5">
                    <FilePdf size={15} weight="bold" /> {t("certificate")}
                  </Button>
                  {d.collateral && (
                    <div className="mt-3 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2" data-testid={`my-td-collateral-${d.id}`}>
                      <ShieldCheck size={16} weight="duotone" className="text-amber-700 shrink-0 mt-0.5" />
                      <p className="text-xs text-amber-800"><b>En garantía.</b> {d.collateral_note}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

        </div>
        )}

        {section === "tienda" && (
          <MemberStore savingsAccts={savingsAccts} onPurchased={load} />
        )}

        {/* REFERIDOS */}
        {section === "referidos" && referral && (
          <div className="mt-8 space-y-6" data-testid="referral-section">
            <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
              <div className="flex items-center gap-2.5 mb-4">
                <div className="h-10 w-10 rounded-lg bg-emerald-100 flex items-center justify-center"><ShareNetwork size={22} weight="duotone" className="text-emerald-800" /></div>
                <h2 className="font-display font-bold text-emerald-900 text-xl">{t("referral_title")}</h2>
              </div>
              <Label className="text-emerald-900 font-semibold text-sm">{t("ref_link")}</Label>
              <div className="mt-1.5 flex flex-wrap gap-2">
                <input readOnly data-testid="ref-link-input" value={`${window.location.origin}/register?ref=${referral.ref_code}`} className="flex-1 min-w-0 basis-full sm:basis-0 h-11 rounded-md border border-emerald-200 px-3 font-mono-num text-sm bg-emerald-50/50" />
                <Button data-testid="ref-copy-btn" onClick={copyRefLink} className="flex-1 sm:flex-none h-11 bg-emerald-800 hover:bg-emerald-900 gap-1.5"><Copy size={16} weight="bold" /> {t("copy")}</Button>
                <a
                  data-testid="ref-whatsapp-btn"
                  href={`https://wa.me/?text=${encodeURIComponent(`${t("invited_note")}\n\n${t("referral_earnings")}: ${money(referral.earnings_total, referral.currency)}\n${t("level")} 2/3/4: ${referral.downline.level2}/${referral.downline.level3}/${referral.downline.level4}\n\n${window.location.origin}/register?ref=${referral.ref_code}`)}`}
                  target="_blank" rel="noopener noreferrer"
                  className="flex-1 sm:flex-none justify-center h-11 inline-flex items-center gap-1.5 rounded-md bg-[#25D366] px-4 text-sm font-semibold text-white hover:bg-[#1eb85a] transition-colors"
                >
                  <WhatsappLogo size={18} weight="fill" /> WhatsApp
                </a>
              </div>
              {!referral.in_tree && (
                <div className="mt-4 flex items-center justify-between flex-wrap gap-3 rounded-lg bg-amber-50 border border-amber-200 p-4">
                  <span className="text-sm text-amber-800 flex items-center gap-2"><Gift size={18} weight="fill" /> {t("not_in_tree")}</span>
                  <Button data-testid="ref-join-btn" onClick={joinReferral} size="sm" className="bg-emerald-800 hover:bg-emerald-900">{t("join_plan")}</Button>
                </div>
              )}
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-5" data-testid="ref-earnings-card">
                <p className="text-xs uppercase tracking-wider text-slate-400">{t("referral_earnings")}</p>
                <p className="font-mono-num text-2xl font-bold text-emerald-700 mt-1">{money(referral.earnings_total, referral.currency)}</p>
              </div>
              {[["level2", 2], ["level3", 3], ["level4", 4]].map(([k, lvl]) => (
                <div key={k} className="bg-white rounded-xl border border-gray-100 shadow-sm p-5" data-testid={`ref-count-${lvl}`}>
                  <p className="text-xs uppercase tracking-wider text-slate-400">{t("level")} {lvl}</p>
                  <p className="font-mono-num text-2xl font-bold text-emerald-900 mt-1">{referral.downline[k]}</p>
                  <p className="text-[11px] text-slate-400">{money((referral.level_amounts[String(lvl)] || 0) / (lvl === 2 ? 2 : lvl === 3 ? 4 : 8), referral.currency)} {t("per_person")}</p>
                </div>
              ))}
            </div>

            <ReferralCalculator cfg={{ level2_amount: referral.level_amounts["2"], level3_amount: referral.level_amounts["3"], level4_amount: referral.level_amounts["4"], currency: referral.currency }} refCode={referral.ref_code} />

            <MonthlyRankingCard />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-amber-50 rounded-xl border border-amber-200 p-5" data-testid="ref-pending-card">
                <p className="text-xs uppercase tracking-wider text-amber-600 flex items-center gap-1.5"><Gift size={14} weight="fill" /> {t("bonus_pending")}</p>
                <p className="font-mono-num text-2xl font-bold text-amber-700 mt-1">{money(referral.bonus_pending_total || 0, referral.currency)}</p>
                <p className="text-[11px] text-amber-600 mt-1">{t("bonus_pending_hint")}</p>
              </div>
              <div className="bg-slate-50 rounded-xl border border-slate-200 p-5" data-testid="ref-waiting-card">
                <p className="text-xs uppercase tracking-wider text-slate-500">{t("bonus_waiting")}</p>
                <p className="font-mono-num text-2xl font-bold text-slate-700 mt-1">{money(referral.bonus_waiting_total || 0, referral.currency)}</p>
                <p className="text-[11px] text-slate-500 mt-1">{t("bonus_waiting_hint")}</p>
              </div>
            </div>

            {(referral.bonuses || []).length > 0 && (
              <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-x-auto" data-testid="ref-bonuses-table">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="text-left text-slate-400 border-b border-gray-100">
                      <th className="px-4 py-2.5 font-medium">{t("level")}</th>
                      <th className="px-4 py-2.5 font-medium text-right">{t("mv_amount")}</th>
                      <th className="px-4 py-2.5 font-medium">{t("status")}</th>
                      <th className="px-4 py-2.5 font-medium">{t("bonus_payable_at")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {referral.bonuses.map((b, i) => (
                      <tr key={`${b.level}-${b.created_at}-${i}`} className="border-b border-gray-50 last:border-0" data-testid={`ref-bonus-row-${i}`}>
                        <td className="px-4 py-2.5 text-emerald-900 font-semibold">{t("level")} {b.level}</td>
                        <td className="px-4 py-2.5 text-right font-mono-num text-emerald-800">{money(b.amount, b.currency)}</td>
                        <td className="px-4 py-2.5">
                          {b.status === "paid" && <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-emerald-100 text-emerald-700">{t("bonus_status_paid")}</span>}
                          {b.status === "pending" && <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-amber-100 text-amber-700">{t("bonus_status_pending")}</span>}
                          {b.status === "waiting" && <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-slate-100 text-slate-600">{t("bonus_status_waiting")}</span>}
                        </td>
                        <td className="px-4 py-2.5 text-slate-500">{b.status === "pending" && b.payable_at ? b.payable_at.slice(0, 10) : (b.status === "paid" && b.paid_at ? b.paid_at.slice(0, 10) : "—")}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}


        {/* TRANSFERENCIAS */}
        {section === "transferencias" && (        <div className="mt-8" data-testid="transfers-panel">
          <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
            <h2 className="font-display font-bold text-emerald-900 text-xl">{t("transfers_tab")}</h2>
            {transfers.length > 0 && (
              <div className="relative w-full sm:w-72">
                <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <Input data-testid="client-transfers-search" value={transferSearch} onChange={(e) => setTransferSearch(e.target.value)} placeholder={t("transfers_search_ph")} className="h-10 pl-9" />
              </div>
            )}
          </div>
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-5 mb-4" data-testid="beneficiaries-panel">
            <h3 className="font-display font-bold text-emerald-900 mb-1 flex items-center gap-2"><Users size={20} weight="duotone" className="text-emerald-700" /> Beneficiarios guardados</h3>
            <p className="text-xs text-slate-400 mb-3">Guarda a quién sueles enviar dinero (por N° de cuenta, correo o teléfono) y elígelo al transferir.</p>
            <div className="flex flex-col sm:flex-row gap-2 mb-3">
              <Input data-testid="beneficiary-identifier" value={benIdentifier} onChange={(e) => setBenIdentifier(e.target.value)} placeholder="N° de cuenta, correo o teléfono" className="h-10" />
              <Input data-testid="beneficiary-alias" value={benAlias} onChange={(e) => setBenAlias(e.target.value)} placeholder="Alias (opcional)" className="h-10 sm:w-48" />
              <Button data-testid="beneficiary-add-btn" onClick={addBeneficiary} disabled={benBusy} className="bg-emerald-800 hover:bg-emerald-900 gap-1.5 shrink-0"><Plus size={15} weight="bold" /> Agregar</Button>
            </div>
            {beneficiaries.length === 0 ? (
              <p className="text-slate-400 text-sm" data-testid="beneficiaries-empty">Aún no has guardado beneficiarios.</p>
            ) : (
              <div className="space-y-2" data-testid="beneficiaries-list">
                {beneficiaries.map((b) => (
                  <div key={b.id} className="flex items-center justify-between rounded-lg border border-gray-100 px-3 py-2" data-testid={`beneficiary-${b.id}`}>
                    <div>
                      <p className="font-semibold text-emerald-900 text-sm">{b.alias ? b.alias + " · " : ""}{b.holder_name}</p>
                      <p className="text-xs text-slate-400 font-mono-num">{b.account_number} · {b.currency}</p>
                    </div>
                    <Button data-testid={`beneficiary-del-${b.id}`} size="sm" variant="outline" onClick={() => removeBeneficiary(b.id)} className="border-red-200 text-red-700 hover:bg-red-50"><Trash size={14} weight="bold" /></Button>
                  </div>
                ))}
              </div>
            )}
          </div>
          {transfers.length === 0 ? (
            <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-10 text-center text-slate-400" data-testid="transfers-empty">{t("no_transfers")}</div>
          ) : (() => {
            const q = transferSearch.trim().toLowerCase();
            const shown = q ? transfers.filter((tr) => [tr.reference, tr.counterpart_name, tr.counterpart_account].some((v) => String(v || "").toLowerCase().includes(q))) : transfers;
            return (
            <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-slate-400 border-b border-gray-100">
                    <th className="px-4 py-3 font-medium">{t("date")}</th>
                    <th className="px-4 py-3 font-medium">{t("reference")}</th>
                    <th className="px-4 py-3 font-medium">{t("counterpart")}</th>
                    <th className="px-4 py-3 font-medium text-right">{t("mv_amount")}</th>
                    <th className="px-4 py-3 font-medium text-right">{t("receipt")}</th>
                  </tr>
                </thead>
                <tbody>
                  {shown.length === 0 ? (
                    <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400" data-testid="transfers-no-match">{t("no_transfers")}</td></tr>
                  ) : shown.map((tr) => (
                    <tr key={tr.id} className="border-b border-gray-50 last:border-0" data-testid={`transfer-row-${tr.id}`}>
                      <td className="px-4 py-3 text-slate-600">{(tr.created_at || "").slice(0, 10)}</td>
                      <td className="px-4 py-3 font-mono-num text-slate-500">{tr.reference}</td>
                      <td className="px-4 py-3">
                        <span className={`inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded mr-2 ${tr.direction === "out" ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"}`}>{tr.direction === "out" ? t("transfer_out") : t("transfer_in")}</span>
                        <span className="text-emerald-900 font-semibold">{tr.counterpart_name}</span>
                        <span className="text-xs text-slate-400 ml-1 font-mono-num">{tr.counterpart_account}</span>
                      </td>
                      <td className={`px-4 py-3 text-right font-mono-num font-bold ${tr.direction === "out" ? "text-amber-700" : "text-emerald-700"}`}>{tr.direction === "out" ? "−" : "+"}{money(tr.amount, tr.currency)}</td>
                      <td className="px-4 py-3 text-right">
                        <Button data-testid={`transfer-receipt-${tr.id}`} size="sm" variant="outline" onClick={() => downloadTransferReceipt(tr.id, tr.reference)} className="border-emerald-300 text-emerald-800 hover:bg-emerald-50 gap-1.5"><FilePdf size={14} weight="bold" /> {t("receipt")}</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            );
          })()}
        </div>
        )}


        {section === "envios" && (
          <ClientRemittances savingsAccts={savingsAccts} />
        )}

        {section === "boletos" && (
          <MyRaffleTickets />
        )}

        {section === "calendario" && (
          <CalendarPanel />
        )}

        {section === "equipo" && (
          <TeamView />
        )}

        {section === "documentos" && (
          <MyDocuments />
        )}

        {section === "solicitar" && (
          <LoanRequestPanel />
        )}

        {section === "actividades" && (
          <MyActivities />
        )}


        {/* ESTADO DE CUENTA */}
        {section === "estado" && (
        <div className="mt-8 bg-white rounded-xl border border-gray-100 shadow-sm p-8 max-w-xl" data-testid="statement-panel">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-12 w-12 rounded-lg bg-emerald-100 flex items-center justify-center">
              <FilePdf size={26} weight="duotone" className="text-emerald-800" />
            </div>
            <div>
              <h2 className="font-display font-bold text-emerald-900 text-xl">{t("statement")}</h2>
              <p className="text-sm text-slate-500">{t("statement_sub")}</p>
            </div>
          </div>
          <Button data-testid="download-statement-btn" onClick={downloadStatement} disabled={downloading} className="bg-emerald-800 hover:bg-emerald-900 gap-2 h-11">
            <FilePdf size={18} weight="bold" /> {downloading ? t("generating") : t("download_statement")}
          </Button>
        </div>
        )}
      </div>
    </div>
  );
}


const DOC_BACKEND = process.env.REACT_APP_BACKEND_URL;

const APP_STATUS_STYLE = {
  pending: "bg-amber-100 text-amber-800",
  approved: "bg-emerald-100 text-emerald-800",
  needs_info: "bg-blue-100 text-blue-800",
  rejected: "bg-red-100 text-red-700",
};

const EMPTY_LOAN_FORM = {
  amount: "", currency: "DOP", purpose: "", term_months: "", payment_frequency: "mensual",
  monthly_income: "", occupation: "", employer: "", reference_name: "", reference_phone: "",
  guarantor_name: "", comment: "",
};

function LoanRequestPanel() {
  const [apps, setApps] = useState([]);
  const [form, setForm] = useState(EMPTY_LOAN_FORM);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/me/loan-applications").then((r) => setApps(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async () => {
    if (!form.amount || Number(form.amount) <= 0) { toast.error("Indica el monto solicitado"); return; }
    if (!form.purpose.trim()) { toast.error("Indica el propósito del préstamo"); return; }
    if (!form.term_months || Number(form.term_months) <= 0) { toast.error("Indica el plazo en meses"); return; }
    setBusy(true);
    try {
      await api.post("/me/loan-applications", {
        amount: Number(form.amount), currency: form.currency, purpose: form.purpose.trim(),
        term_months: Number(form.term_months), payment_frequency: form.payment_frequency,
        monthly_income: Number(form.monthly_income) || 0, occupation: form.occupation, employer: form.employer,
        reference_name: form.reference_name, reference_phone: form.reference_phone,
        guarantor_name: form.guarantor_name, comment: form.comment,
      });
      toast.success("Solicitud enviada. GEHI la revisará pronto.");
      setForm(EMPTY_LOAN_FORM);
      setOpen(false);
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };

  const uploadDoc = async (aid, file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post(`/me/loan-applications/${aid}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Documento adjuntado");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  return (
    <div className="mt-6" data-testid="loan-request-panel">
      <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <HandCoins size={26} weight="duotone" className="text-emerald-700" />
          <h2 className="font-display text-2xl text-emerald-900">Solicitar préstamo</h2>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button data-testid="new-loan-request-btn" className="bg-emerald-800 hover:bg-emerald-900 gap-2 h-11">
              <HandCoins size={18} weight="bold" /> Nueva solicitud
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="loan-request-dialog">
            <DialogHeader>
              <DialogTitle>Solicitud de préstamo</DialogTitle>
              <DialogDescription>Completa tus datos. GEHI revisará tu solicitud y te responderá.</DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-1">
              <div className="grid grid-cols-3 gap-3">
                <div className="col-span-2">
                  <Label>Monto solicitado *</Label>
                  <Input data-testid="loan-amount-input" type="number" min="0" className="mt-1.5 h-11" value={form.amount} onChange={set("amount")} placeholder="0.00" />
                </div>
                <div>
                  <Label>Moneda</Label>
                  <select data-testid="loan-currency-select" className="mt-1.5 h-11 w-full rounded-md border border-input bg-background px-3 text-sm" value={form.currency} onChange={set("currency")}>
                    <option value="DOP">RD$</option>
                    <option value="USD">US$</option>
                  </select>
                </div>
              </div>
              <div>
                <Label>Propósito del préstamo *</Label>
                <textarea data-testid="loan-purpose-input" className="mt-1.5 w-full rounded-md border border-input bg-background px-3 py-2 text-sm min-h-[70px]" value={form.purpose} onChange={set("purpose")} placeholder="Ej: mejoras del hogar, capital de trabajo, salud..." />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label>Plazo (meses) *</Label>
                  <Input data-testid="loan-term-input" type="number" min="1" className="mt-1.5 h-11" value={form.term_months} onChange={set("term_months")} placeholder="12" />
                </div>
                <div>
                  <Label>Frecuencia de pago</Label>
                  <select data-testid="loan-frequency-select" className="mt-1.5 h-11 w-full rounded-md border border-input bg-background px-3 text-sm" value={form.payment_frequency} onChange={set("payment_frequency")}>
                    <option value="mensual">Mensual</option>
                    <option value="quincenal">Quincenal</option>
                    <option value="semanal">Semanal</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label>Ingreso mensual</Label>
                  <Input data-testid="loan-income-input" type="number" min="0" className="mt-1.5 h-11" value={form.monthly_income} onChange={set("monthly_income")} placeholder="0.00" />
                </div>
                <div>
                  <Label>Ocupación</Label>
                  <Input data-testid="loan-occupation-input" className="mt-1.5 h-11" value={form.occupation} onChange={set("occupation")} />
                </div>
              </div>
              <div>
                <Label>Lugar de trabajo</Label>
                <Input data-testid="loan-employer-input" className="mt-1.5 h-11" value={form.employer} onChange={set("employer")} />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label>Referencia (nombre)</Label>
                  <Input data-testid="loan-ref-name-input" className="mt-1.5 h-11" value={form.reference_name} onChange={set("reference_name")} />
                </div>
                <div>
                  <Label>Referencia (teléfono)</Label>
                  <Input data-testid="loan-ref-phone-input" className="mt-1.5 h-11" value={form.reference_phone} onChange={set("reference_phone")} />
                </div>
              </div>
              <div>
                <Label>Garante / co-deudor (opcional)</Label>
                <Input data-testid="loan-guarantor-input" className="mt-1.5 h-11" value={form.guarantor_name} onChange={set("guarantor_name")} />
              </div>
              <div>
                <Label>Comentario adicional</Label>
                <textarea data-testid="loan-comment-input" className="mt-1.5 w-full rounded-md border border-input bg-background px-3 py-2 text-sm min-h-[60px]" value={form.comment} onChange={set("comment")} />
              </div>
            </div>
            <DialogFooter>
              <Button data-testid="submit-loan-request-btn" onClick={submit} disabled={busy} className="bg-emerald-800 hover:bg-emerald-900">
                {busy ? "Enviando..." : "Enviar solicitud"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      {apps.length === 0 ? (
        <div className="bg-white rounded-xl border border-dashed border-gray-300 p-10 text-center text-slate-500" data-testid="no-loan-requests">
          Aún no has enviado ninguna solicitud de préstamo. Toca “Nueva solicitud” para empezar.
        </div>
      ) : (
        <div className="space-y-4">
          {apps.map((a) => (
            <div key={a.id} className="bg-white rounded-xl border border-gray-100 shadow-sm p-6" data-testid={`my-loan-request-${a.id}`}>
              <div className="flex items-start justify-between flex-wrap gap-3">
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-mono-num text-sm text-emerald-700 font-semibold">{a.application_number}</span>
                    <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${APP_STATUS_STYLE[a.status] || "bg-slate-100"}`} data-testid={`my-app-status-${a.id}`}>{a.status_label}</span>
                  </div>
                  <p className="text-sm text-slate-500 mt-1">{a.purpose}</p>
                </div>
                <div className="text-right">
                  <p className="font-mono-num text-2xl font-bold text-emerald-900">{money(a.amount, a.currency)}</p>
                  <p className="text-xs text-slate-500">{a.term_months} meses · {a.payment_frequency}</p>
                </div>
              </div>
              {a.decision_message && (
                <div className="mt-3 text-sm bg-slate-50 rounded-lg px-3 py-2 text-slate-600"><span className="font-semibold">Respuesta de GEHI:</span> {a.decision_message}</div>
              )}
              {a.loan_created && (
                <div className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold bg-emerald-100 text-emerald-800 px-3 py-1.5 rounded-full" data-testid={`my-app-loan-${a.id}`}>
                  <HandCoins size={14} weight="bold" /> Préstamo creado: {a.loan_number}
                </div>
              )}
              <p className="mt-3 text-[11px] text-slate-400" data-testid={`my-app-history-${a.id}`}>
                Solicitado el {(a.created_at || "").slice(0, 10)}
                {a.decided_at ? ` · Revisado el ${(a.decided_at || "").slice(0, 10)}${a.decided_by ? ` por ${a.decided_by}` : ""}` : ""}
              </p>
              {a.documents && a.documents.length > 0 && (
                <div className="mt-3 flex flex-wrap gap-2">
                  {a.documents.map((d) => (
                    <span key={d.id} className="inline-flex items-center gap-1.5 text-xs bg-emerald-50 text-emerald-800 px-2.5 py-1 rounded-lg border border-emerald-100">
                      <FilePdf size={14} weight="bold" /> {d.label}
                    </span>
                  ))}
                </div>
              )}
              {a.status !== "approved" && a.status !== "rejected" && (
                <label className="mt-3 inline-flex items-center gap-2 text-sm text-emerald-700 cursor-pointer hover:underline" data-testid={`attach-doc-${a.id}`}>
                  <FilePdf size={16} weight="bold" /> Adjuntar documento
                  <input type="file" className="hidden" accept="image/*,.pdf" onChange={(e) => uploadDoc(a.id, e.target.files?.[0])} />
                </label>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function MyActivities() {
  return (
    <div className="mt-6" data-testid="my-activities">
      <div className="flex items-center gap-2 mb-5">
        <ClockCounterClockwise size={26} weight="duotone" className="text-emerald-700" />
        <h2 className="font-display text-2xl text-emerald-900">Actividades</h2>
      </div>
      <ActivityPanel baseUrl="/me/activities" emptyText="Aún no tienes actividades registradas." />
    </div>
  );
}

function MyLoanCard({ l, onCert }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6" data-testid={`my-loan-${l.id}`}>
      <div className="flex items-center gap-2.5 mb-3">
        <div className="h-10 w-10 rounded-lg bg-amber-100 flex items-center justify-center"><HandCoins size={22} weight="duotone" className="text-amber-700" /></div>
        <div>
          <p className="font-display font-bold text-emerald-900 leading-none">{t("loan")}</p>
          <p className="font-mono-num text-xs text-amber-600 mt-1">{l.loan_number}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div><p className="text-slate-400 text-xs">{t("loan_amount_label")}</p><p className="font-mono-num font-bold text-emerald-900">{money(l.principal, l.currency)}</p></div>
        <div><p className="text-slate-400 text-xs">{t("monthly_payment")}</p><p className="font-mono-num font-bold text-emerald-900">{money(l.monthly_payment, l.currency)}</p></div>
        <div><p className="text-slate-400 text-xs">{t("interest_rate")}</p><p className="font-mono-num text-emerald-900">{l.annual_rate}% · {l.term_months} {t("months_unit")}</p></div>
        <div><p className="text-slate-400 text-xs">{t("remaining_balance")}</p>{l.paid_off ? <span className="inline-block text-[11px] font-semibold px-2 py-0.5 rounded bg-emerald-100 text-emerald-700">{t("paid_off")}</span> : <p className="font-mono-num font-bold text-amber-700">{money(l.remaining, l.currency)}</p>}</div>
      </div>
      <div className="mt-4 flex flex-col gap-2">
        <Button data-testid={`cert-myloan-${l.id}`} onClick={() => onCert(l)} size="sm" variant="outline" className="w-full border-emerald-300 text-emerald-800 hover:bg-emerald-50 gap-1.5"><FilePdf size={15} weight="bold" /> {t("certificate")}</Button>
        {l.schedule && l.schedule.length > 0 && (
          <Button data-testid={`schedule-toggle-${l.id}`} onClick={() => setOpen((o) => !o)} size="sm" variant="outline" className="w-full border-amber-300 text-amber-700 hover:bg-amber-50 gap-1.5">
            <CalendarCheck size={15} weight="bold" /> {open ? "Ocultar calendario de pagos" : "Ver calendario de pagos"}
          </Button>
        )}
      </div>
      {open && l.schedule && l.schedule.length > 0 && (
        <div className="mt-3 max-h-56 overflow-y-auto rounded-lg border border-gray-100" data-testid={`schedule-table-${l.id}`}>
          <table className="w-full text-sm font-mono-num">
            <thead className="bg-emerald-50 text-emerald-800 sticky top-0">
              <tr>
                <th className="px-3 py-2 text-left">{t("period")}</th>
                <th className="px-3 py-2 text-right">{t("payment")}</th>
                <th className="px-3 py-2 text-right">{t("principal")}</th>
                <th className="px-3 py-2 text-right">{t("interest")}</th>
                <th className="px-3 py-2 text-right">{t("balance")}</th>
              </tr>
            </thead>
            <tbody>
              {l.schedule.map((r) => (
                <tr key={r.period} className="border-t border-gray-100">
                  <td className="px-3 py-1.5 text-slate-400">{r.period}</td>
                  <td className="px-3 py-1.5 text-right">{money(r.payment, l.currency)}</td>
                  <td className="px-3 py-1.5 text-right text-emerald-700">{money(r.principal, l.currency)}</td>
                  <td className="px-3 py-1.5 text-right text-amber-600">{money(r.interest, l.currency)}</td>
                  <td className="px-3 py-1.5 text-right">{money(r.balance, l.currency)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function MyDocuments() {
  const { t } = useI18n();
  const [docs, setDocs] = useState([]);
  useEffect(() => { api.get("/me/id-documents").then((r) => setDocs(r.data)).catch(() => setDocs([])); }, []);
  const daysTo = (d) => (d ? Math.ceil((new Date(d + "T00:00:00") - new Date()) / 86400000) : null);
  const typeLabel = (tp) => t(`doc_type_${tp}`);
  const isPdf = (url) => (url || "").toLowerCase().endsWith(".pdf");
  return (
    <div className="mt-6" data-testid="my-documents">
      <div className="flex items-center gap-2 mb-5">
        <IdentificationCard size={26} weight="duotone" className="text-emerald-700" />
        <h2 className="font-display text-2xl text-emerald-900">{t("my_documents_tab")}</h2>
      </div>
      {docs.length === 0 ? (
        <div className="bg-white rounded-xl border border-dashed border-gray-300 p-10 text-center text-slate-400" data-testid="my-documents-empty">{t("my_documents_empty")}</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {docs.map((d) => {
            const n = daysTo(d.expires_at);
            const es = n === null ? "" : n < 0 ? "expired" : n <= 30 ? "soon" : "";
            return (
              <div key={d.id} className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden" data-testid={`my-doc-${d.id}`}>
                <a href={`${DOC_BACKEND}${d.image_url}`} target="_blank" rel="noreferrer" className="block bg-slate-50 h-40 flex items-center justify-center overflow-hidden">
                  {isPdf(d.image_url) ? <span className="text-slate-400 flex flex-col items-center gap-1"><Eye size={26} /> PDF</span> : <img src={`${DOC_BACKEND}${d.image_url}`} alt={d.person_name} className="w-full h-full object-cover" />}
                </a>
                <div className="p-4">
                  <p className="font-semibold text-emerald-900 truncate">{d.person_name}</p>
                  <p className="text-xs text-slate-500">{typeLabel(d.doc_type)}{d.number ? ` · ${d.number}` : ""}</p>
                  {d.expires_at ? <p className={`text-xs mt-1 font-semibold ${es === "expired" ? "text-red-600" : es === "soon" ? "text-amber-600" : "text-slate-500"}`}>{es === "expired" ? t("doc_expired") : es === "soon" ? t("doc_expiring_soon") : t("doc_expires")}: {d.expires_at}</p> : null}
                  <a href={`${DOC_BACKEND}${d.image_url}`} target="_blank" rel="noreferrer" data-testid={`my-doc-view-${d.id}`} className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 hover:text-emerald-900 mt-3"><Eye size={14} weight="bold" /> {t("doc_view")}</a>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
